import { SB } from '@play-co/replicant';

export const regionsSchema = {
  regions: SB.object({
    currentRegion: SB.string().default(''),
  }),
};
